import { createActions, handleActions } from 'redux-actions';
import apiCall from '../api';

const defaultState = {
  loading: true,
  data: null
};
const _actions = createActions({
  match: {
    load: matchId => async dispatch => {
      dispatch(actions.setLoading(true));
      const result = await apiCall('/matches/' + matchId, {
        method: 'GET'
      });
      if (result.success) {
        dispatch(actions.loadDone(result.payload));
      }
      dispatch(actions.setLoading(false));
    },
    loadDone: payload => payload,
    setLoading: payload => payload
  }
});
const actions = _actions.match;

const setLoading = (state, action) => {
  return Object.assign({}, state, { loading: action.payload });
};
const loadDone = (state, action) => {
  return Object.assign({}, state, { data: action.payload });
};

const reducer = handleActions(
  {
    [actions.setLoading]: setLoading,
    [actions.loadDone]: loadDone
  },
  defaultState
);

export { actions, reducer };
